import {BasePrintEmailComponent} from './base-print-email.component';
import { BaseSearchResultsTableComponent } from './base-search-results-table.component';
import { NgModule }      from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimateOpenDirective } from './animate-open.directive';
import { FocusableDirective } from './focusable.directive';
import { PdfComponent } from './pdf/pdf.component';
import { SsMultiselectDropdownTabindexMigratorDirective } from './ss-multiselect-dropdown-tabindex-migrator.directive';
import { PageNotFoundComponent } from './page-not-found.component';
import { PublicAccessTerminalComponent } from './public-access-terminal.component';
import { PublicAccessTerminalService } from './public-access-terminal.service';
import { RoutingHistoryService } from './routing-history.service';

@NgModule({
  declarations: [ AnimateOpenDirective,
                  BaseSearchResultsTableComponent,
                  BasePrintEmailComponent,
                  FocusableDirective,
                  PdfComponent,
                  SsMultiselectDropdownTabindexMigratorDirective,
                  PageNotFoundComponent,
                  PublicAccessTerminalComponent
                   ],
  imports: [ CommonModule ],
  exports: [ AnimateOpenDirective,
             FocusableDirective,
             PdfComponent,
             SsMultiselectDropdownTabindexMigratorDirective
              ],
  providers: [ PublicAccessTerminalService, RoutingHistoryService]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/shared.module.ts